<div id="side-menu" [ngClass]="state()">

  <header>
    <button class="fold-btn" (click)="toggleState()" [class]="state()"
      [tooltip]="(state() === 'unfold' ? 'side_menu.tooltip.close_menu' : 'side_menu.tooltip.open_menu') | translate" tooltipPosition="bottom" [tooltipDelay]="500">
      <span></span>
      <span></span>
      <span></span>
    </button>
    @if (state() === 'unfold') {
    <div id="side-menu-logo" [routerLink]="['/']">
      <img src="assets/images/kin_best_logo.png" alt="Kinomap Logo" />
    </div>
    }
  </header>

  <span class="divider"></span>
  <button class="create-btn cta-primary" (click)="router.navigate(['content-creation'])"
    [disabled]="contentCreationAvaible">
    <kin-icon name="add_circle" />
    <span class="label">
      {{ 'side_menu.create' | translate | upperFirstLetter }}
    </span>
  </button>

  @for (category of menuCategories; track $index) {
  <nav [aria-label]="category.name">
    <label>{{ 'side_menu.category.' + category.name | translate }}</label>
    <ul>
      @for (item of category.items; track $index) {
      <li [ngClass]="{ 'active-item': isActive(item.name) }" [tooltip]="
              state() === 'fold'
                ? ('page.' + item.name + '.name' | translate | upperFirstLetter)
                : null
            " [tooltipPosition]="'right'">
        <button (click)="router.navigate([item.name])" (mouseenter)="setHoveredItem(item.name)"
          (mouseleave)="setHoveredItem(null)">
          <kin-icon [color]="getIconColor(item.name)" [name]="item.icon" />
          <p>{{ 'page.' + item.name + '.name' | translate | upperFirstLetter }}</p>
        </button>
      </li>
      }
    </ul>
  </nav>
  }

  <footer>
    <button>
      <kin-icon name="arrow_left" color="#428FF3" [size]="16" />
      {{ 'side_menu.back_to_kinomap' | translate | titlecase }}
    </button>
  </footer>
</div>